<template>
	<div class="aSelectField field">

		<!-- mask to close field if user click outside the field -->
		<div 
		class="inputmask" 
		v-if="isOptionsListOpen"
		@click="closeWithoutSelection"
		></div>

		<div class="selectfield">
			<label :for="fieldname"><span v-html="$t(`inputsTexts.${translationSource}.label`)"></span><span v-if="isRequired" class="req" tabindex="-1">&nbsp;*</span></label>

			<div class="dropdown" :class="{'open': isOptionsListOpen}">

				<input 
				type="text"
				autocomplete="off"
				:id="fieldname"
				v-model="textInField"
				@input="userChangedInput"
				:placeholder = "$t(`inputsTexts.${translationSource}.placeholder`)"
				:class="{'hasSuccess': isInSuccess, 'hasError': isInError, 'isLoading': isLoading}"
				@keyup.prevent.down="keyPressedDown"
				@keyup.prevent.up = "keyPressedUp"
				@keyup.prevent.enter = "keyPressedEnter"
				:disabled="isDisabled"
				autocapitalize="off" 
				spellcheck="false" 
				autocorrect="off"
				>

				<!-- Toggler -->
				<div class="toggle" @click="toggleListOpeness()" :class="{'active': isOptionsListOpen}">
					<span class="arrow-up" v-show="isOptionsListOpen">
						<svg height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
						viewBox="0 0 36 36" xml:space="preserve">
						<g>
							<polygon points="0,24 18,6 36,24 31,28 18,15 5,28"/>
						</g>
					</svg>
				</span>
				<span class="arrow-down" v-show="!isOptionsListOpen">
					<svg height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
					viewBox="0 0 36 36" xml:space="preserve">
					<g>
						<polygon  points="5,8 18,21 31,8 36,12 18,30 0,12"/>
					</g>
				</svg>
			</span>
		</div>

		<!-- Options list -->
		<ul
		v-show="isOptionsListOpen"
		class="options-list"
		tabindex="-1">
		<li 
		v-for="(option, index) in optionsList"
		:key="index"
		@click="selectThisOption(option, index)"
		:class="{'active': currentActiveOption === index}"
		tabindex="0"
		>{{option.synonym}}</li>
		<li v-show="noResult" @click="closeWithoutSelection">{{$t('inputLabel.noResult')}}</li>
	</ul>

</div>
</div>

<div class="errorMessage" v-if="isInError">{{errorMessage}}</div>
<div class="helper"><span v-html="$t(`inputsTexts.${translationSource}.helper`)"></span></div>

</div>
</template>

<!-- ================================================================================== -->

<script>
	import FormFields from "../mixins/FormFields";
	import customLog from "../mixins/CustomLog";

	export default {
		name:"SelectFree",
		mixins: [
			customLog,
			FormFields,
			],
		props: {
			dataArray : { 
				/* only for free select field */
				type: Array,
				required: true,
			},
			caractersBeforeOpenList : {
				type: Number,
				required: false,
			default: 3
			},
			autocomplete: {
				type: Boolean,
				required: true,
			},
			isDisabled: {
				type: Boolean,
				required: false,
			default: false,
			}
		},
		data(){
			return {
				isOptionsListOpen: false,
				optionsList: [],
				displayedInTheField: null,
				noResult: false,
				currentActiveOption: null,
			}
		},
		computed: {
			textInField: {
				get(){
					return this.displayedInTheField;
				},
				set(newVal){
					this.displayedInTheField = newVal;
				}
			}
		},

		methods: {

			keyPressedDown(){
				if(this.isOptionsListOpen && this.currentActiveOption < this.optionsList.length -1){
					this.downOneItem();
				}
				if(!this.isOptionsListOpen){
					this.makeNewOptionsList(false);
					this.isOptionsListOpen = true;
				}
			},

			keyPressedUp(){
				if(this.isOptionsListOpen && this.currentActiveOption > 0){
					this.upOneItem();
				}else{
					this.closeOptionsList();
					this.currentActiveOption = null;
				}
			},

			keyPressedEnter(){
				if(this.isOptionsListOpen){
					this.selectThisOption(this.optionsList[this.currentActiveOption], this.currentActiveOption);
				}
			},

			upOneItem(){
				this.currentActiveOption -= 1;
			},

			downOneItem(){
				this.currentActiveOption += 1;
			},

			selectThisOption(option, index){
				this.log(`User choose item ${option.id} - ${option.synonym}`, 'low');
				this.displayedInTheField = option.synonym;
				this.currentActiveOption = index;
				this.closeOptionsList(option.id);
			},

			closeWithoutSelection(){
				this.textInField = "";
				this.closeOptionsList();
				this.currentActiveOption = null; /* maybe could be inchanged instead? */
				this.runValidationProcess();
				this.$emit('update:modelValue', null);
			},

			toggleListOpeness(){
				this.isOptionsListOpen = !this.isOptionsListOpen;
				if(this.isOptionsListOpen){
					this.displayedInTheField = "";
					this.makeNewOptionsList(this.autocomplete);
				}
			},

			emptyAndCloseList(){
				this.optionsList = [];
				this.closeOptionsList();
			},

			userChangedInput(){
				/* Refresh list of options */
				/* User left no caracters => options list is empty */
				if(this.lengthOfInput === 0){
					this.emptyAndCloseList();
				}
				/* User type some caracters => options list matching strings */
				if(this.lengthOfInput >= this.caractersBeforeOpenList){
					this.makeNewOptionsList(this.autocomplete);
					if(!this.isOptionsListOpen){ this.openOptionsList(); }
				}
				/* Display "no result" instead of nothing */
				this.noResult = (this.displayedInTheField.length >= this.caractersBeforeOpenList && this.optionsList.length < 1);
			},

			makeNewOptionsList(bool){
				/* If autocomplete is true, it's a partial list */
				if(bool){
					let userInput = "" + this.displayedInTheField;
					this.optionsList = this.dataArray.filter(option => option.synonym.includes(userInput));
				}
				/* If autocomplete is false, it's a full list */
				if(!bool){
					this.optionsList = this.dataArray;
				}
				this.log("New options list: ", 'low');
				this.log(this.optionsList);
			},

			openOptionsList(){
				/* User open the option list */
				/* remove previous options */
				this.optionsList = [];
				/* recreate new options list */
				this.makeNewOptionsList(this.autocomplete);
				/* DOM open the list */
				this.isOptionsListOpen = true;
			},

			closeOptionsList(id){
				/* User leave the option list */
				this.noResult = false;
				this.isOptionsListOpen = false;
				this.runValidationProcess(id);
			},

			sendDataToForm(id){
				this.log("SelectFree is transmitting data to parent", 'info');
				this.$emit('update:modelValue', id);
			},

			sendValidityOfTheFieldToTheForm(bool){
				this.$emit('runCheck', {fieldname: this.fieldname, valid: bool});
			},

			whatToDoInCaseFieldIsValidated(id){
				this.log("Field content approved", 'success');
				this.sendDataToForm(id);
				this.giveSuccess();
				this.sendValidityOfTheFieldToTheForm(true);
			},

			whatToDoInCaseFieldIsNotValidated(){
				// Either empty or in error
				if(this.lengthOfInput === 0){
					this.sendValidityOfTheFieldToTheForm(false);
				}
				if(this.lengthOfInput > 0){
					this.errorMessage = this.$t('inputsTexts.dropdown.errorData');
					this.giveError();
					this.sendValidityOfTheFieldToTheForm(false);
				}
			},

			isThisFieldValid(){
				/* What is a valid answer ? An answer that has 13 numbers and is exactly in the list */
				let condition1 = this.lengthOfInput === 13;
				let condition2 = this.optionsList.some(elem => parseInt(elem.synonym) === parseInt(this.displayedInTheField));
				this.log(`Condition 1: ${condition1}`, 'wip');
				this.log(`Condition 2: ${condition2}`, 'wip');
				return condition1 && condition2;
			},

			runValidationProcess(id){
				this.removeSuccessOrError();
				this.isThisFieldValid() ? this.whatToDoInCaseFieldIsValidated(id) : this.whatToDoInCaseFieldIsNotValidated();
			}

		},

		mounted(){
			/* If a value exist in the form (reparticipation), it must be loaded. */
			/* Could be === 0 witch is a falsy value => don't use !!this.modelValue */
			if(this.modelValue !== null && this.modelValue !== ''){ 
				this.log("There is a data in the form before user intervene (reparticipation).", 'info');
				let selectedOption = this.dataArray.filter(option => option.id === parseInt(this.modelValue));
				if(selectedOption[0]){
					this.displayedInTheField = selectedOption[0]?.description;
					this.runValidationProcess(selectedOption[0]?.id);
				}
				this.$emit('update:modelValue', parseInt(this.modelValue)); // parseInt the value received from the API, just in case
			}
		},
	}
</script>

<!-- ================================================================================== -->

<style lang="scss" scoped>
</style>
